import { render, staticRenderFns } from "./StudentUsers.vue?vue&type=template&id=5457c611&scoped=true&"
import script from "./StudentUsers.vue?vue&type=script&lang=js&"
export * from "./StudentUsers.vue?vue&type=script&lang=js&"
import style0 from "./StudentUsers.vue?vue&type=style&index=0&id=5457c611&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457c611",
  null
  
)

export default component.exports